<script setup lang="ts">
import { toRefs } from "vue";
import type { QuestionAnswerRowProps } from "./types";

const props = defineProps<QuestionAnswerRowProps>();
const { answer } = toRefs(props);
</script>

<template>
  <div class="border-t border-gray-175 py-4 first:border-t-0" data-testid="recommender-response-answer">
    <div class="text-13p font-bold text-indigo-base" data-testid="recommender-response-question">
      {{ answer.question }}
    </div>
    <div
      class="mt-1.5 text-13p leading-[1.55] text-gray-800 whitespace-pre-line"
      data-testid="recommender-response-answer-text"
    >
      {{ answer.answer }}
    </div>
  </div>
</template>
